import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import { AppState } from "../../store/root.reducer";
import { TfaType } from "../../pages/auth/store/auth.reducer";
import { Confirm2FA } from "../../pages/auth/store/auth.actions";
import { Input, Form } from "../../components/molecules/Form";

import styles from "./modal.module.css";
type TfaModalProps = {
  method: string;
  show: boolean;
  onHide: () => void;
};

export const TfaModal = (props: TfaModalProps) => {
  const dispatch = useDispatch();
  const tfaState: TfaType = useSelector((state: AppState) => state.auth.tfa);
  const [code, setCode] = useState<string>("");

  const onConfirm2FA = () => {
    // token, code, method
    if (!tfaState.token) {
      return;
    }

    dispatch(
      Confirm2FA({
        code,
        token: tfaState.token,
        method: props.method,
      })
    );
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton className={styles.background}>
        <Modal.Title id="contained-modal-title-vcenter">
          Two-Factor Authentication
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.background}>
        <div className="row">
          <div className="col-md-12 text-center">
            {props.method === "GOOGLE" && tfaState.qrcode ? (
              <>
                <div className="mb-3">
                  <img src={tfaState.qrcode} />
                </div>
                <div className="col-3 mx-auto">
                  <input
                    type="number"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    placeholder="Please enter code from Google Authentiator App"
                    className="form-control"
                  />
                </div>
              </>
            ) : (
              <></>
            )}
            {props.method === "EMAIL" ? (
              <>
                <div className="col-3 mx-auto">
                  <Form>
                    <Input
                      type="number"
                      title="Code from email:"
                      placeholder="Please enter code from email"
                      value={code || ""}
                      onChange={setCode}
                    />
                  </Form>
                </div>
              </>
            ) : (
              <></>
            )}
            {props.method === "DISABLE" ? (
              <>
                <div className="col-3 mx-auto">
                  <input
                    type="number"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                    placeholder="Please enter your 2FA code"
                    className="form-control"
                  />
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className={styles.background}>
        <button className="btn btn-success" onClick={props.onHide}>
          Close
        </button>
        <button
          className="btn btn-success"
          onClick={onConfirm2FA}
          disabled={!code || code.length < 6}
        >
          Confirm
        </button>
      </Modal.Footer>
    </Modal>
  );
};
